import { render, staticRenderFns } from "./CustomerFormBasic.vue?vue&type=template&id=60724ec9"
import script from "./CustomerFormBasic.vue?vue&type=script&lang=js"
export * from "./CustomerFormBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports